// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Weishun",
  middleName: "",
  lastName: "Zhong",
  message: " A statistical physicist wondering about intelligence.. ",
    icons: [
    ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/Weishun_IAS.jpg"),
  imageSize: 375,
  message:
    "",
  resume: require("../editable-stuff/resume.pdf"),
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "News",
  gitHubUsername: "weishunzhong", //i.e."johnDoe12Gh"
  reposLength: 4,
  specificRepos: [],
};

// Leadership SECTION
const leadership = {
  show: true,
  heading: "Publications",
  message:
    "",
  images: [
    { 
      img: require("../assets/img/quenched.png"), 
      label: "", 
      paragraph: "" 
    },
    // { 
    //   img: require("../assets/img/quantum.png"), 
    //   label: "", 
    //   paragraph: "" 
    // },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 90 },
    { name: "Mathematica", value: 90 },
    { name: "High Performance Computing", value: 80 },
    { name: "Tensorflow", value: 80 },
    { name: "Pytorch", value: 70 },
    { name: "Qiskit", value: 70 },
  ],
  softSkills: [
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "If you want to chat about science, or do some rock-climbing together, please feel free to email me at",
  email: "wszhong AT ias DOT edu",
};

const experiences = {
  show: true,
  heading: "Employment & Education",
  data: [
    {
      role: 'Member, School of Natural Sciences <br /> Institute for Advanced Study',
      companylogo: require('../assets/img/IAS_small.png'),
      date: 'Sep. 2023 – ',
    }, 
  {
    role: 'Ph.D. Fellow, Center for Brain Sciences <br /> Harvard University',
    companylogo: require('../assets/img/Harvard_small.png'),
    date: 'Sep. 2019 – Jun. 2023',
  }, 
    {
      role: 'Research Intern, IBM Quantum <br /> IBM',
      companylogo: require('../assets/img/IBM_small.png'),
      date: 'May 2022 – Aug 2022',
    },
  {
    role: 'Ph.D. Department of Physics (<a href="https://arxiv.org/abs/2308.01538" target="_blank">thesis</a>) <br />  Massachusetts Institute of Technology',
    companylogo: require('../assets/img/MIT_small.png'),
    date: 'Sep. 2017 – Jun. 2023',
    // thesis: 'Thesis: Non-equilibrium physics: from spin glasses to machine and neural learning'
  },
 {
    role: 'M.S. Physical Sciences Division - Physics <br /> University of Chicago',
    companylogo: require('../assets/img/chicago_small.png'),
    date: 'Sep. 2016 – Jun.2017',
    // thesis: 'Thesis: Associative pattern recognition through macro-molecular self-assembly'
  },
  {
    role: 'B.S. Physics and Mathematics <br /> University of Michigan',
    companylogo: require('../assets/img/michigan_small.png'),
    date: 'Sep. 2013 – May. 2016',
    // thesis: 'Thesis: A Holographic c-Theorem for Schrödinger Spacetimes'
  },
  ]
}

const portfolio = {
  show: true,
  heading: "Recent Projects",
  note: "",
   list: [
      {
      category: "Mobile App",
      title: "Semantic chunking and the entropy of natural language",
      url: "https://arxiv.org/abs/2602.13194",
      notes: "Natural language is both highly structured and only partially predictable. Since Shannon's classic estimate that the entropy rate of printed English is approximately 1 bit per character, this value has been celebrated as a benchmark for language modeling, reflecting a fundamental property across languages: natural texts contain about 80\% redundancy. Yet a central question has remained unresolved: what structural principles account for this large redundancy in language? We demonstrate that a substantial component of this redundancy is encoded in the hierarchical semantic organization of text, and knowing this structure enables prediction of perplexity across different corpora.",
      thumbnail:require("../editable-stuff/semantic_chunking.png")
     },  
    {
      category: "Mobile App",
      title: "Random tree ensemble for meaningful memory",
      url: "https://arxiv.org/abs/2412.01806",
      notes: "Semantic comprehension of narratives has traditionally been studied with a focus on content-specific information, \
              leaving common quantitative features largely unexplored. By treating linguistic clauses as the fundamental 'atoms,' \
              we introduce a statistical mechanics theory of random tree representations to model narratives. Remarkably, our simple toy model captures the \
              statistical regularities observed in large-scale narrative recall experiments without requiring any parameter tuning. Our model further reveals \
              a universal, scale-invariant limit for long narratives, where semantic abstraction emerges naturally as a consequence of the scale-invariance.",
      thumbnail:"/RTM.png",
      videoUrl:"/RTM_1minute.mp4",
      repo: "https://github.com/zhongweishun/RandomTreeModel_PRL?_gl=1*nruass*_gcl_au*MTQ1MDE2Nzk2OC4xNzQ5NzgyODAyLjEyMzUwMTcxNjQuMTc1MDI4MTAwOS4xNzUwMjgxMDA5*_ga*MjAzMjEwNzA3Mi4xNzI2MDE1OTc4*_ga_ZS5V2B2DR1*czE3NTAyODAwNjkkbzUkZzEkdDE3NTAyODEwMDkkajI3JGwwJGg2NjUxNjQyNzE"
     },
    {
      category: "Mobile App",
      title: "Recurrent neural network for hierarchical working memory",
      url: "https://arxiv.org/abs/2408.07637",
      notes: "Our working memory span is extremely limited, typically around only 4 items. How then, are we able to process much larger streams of information, \
              such as long texts or movies? Chunking is hypothesized to be the solution, but its underlying neural mechanism is unknown. We propose an RNN model for \
              chunking, and showed that introducing specialized “chunking neurons’” and incorporating longer-term \
              synaptic plasticity allows the working memory network to spontaneously organize information into chunks, hence significantly increase its capacity.",
      thumbnail:require("../editable-stuff/HWM.png"), 
      videoUrl:require("../editable-stuff/HWM_animation.mp4")
     },
    {
    category: "Mobile App",
    title: "Quantum neural networks for quantum error correction",
    url: "https://arxiv.org/abs/2401.06300",
    notes: "Quantum neural networks (QNNs) are inspired by their classical counterparts, but beyond heuristic considerations, the usefulness of such a concept \
            has yet to be rigorously demonstrated. We show that in the case of decoding quantum information from quantum error-correcting codes, \
            QNNs can provide an almost quadratic improvement in readout error over traditional stabilizer-based quantum error correction, \
            thus establishing a clear scenario where quantum AI methods such as QNNs are proven to provide an advantage over conventional non-AI methods.",
    thumbnail:require("../editable-stuff/QNN.png"), 
    videoUrl:"/QNN_talk.mp4"
   },
   {
    category: "Machine Learning",
    title: "Weight-distribution constrained feedforward neural networks",
    url: "https://arxiv.org/abs/2206.08933",
    present:require("../editable-stuff/Disco_2022_neurips.png"),
    notes: "We constructed a statistical mechanical theory that quantified the effect of imposing arbitrary network weight-distribution constraints. \
            Our theory predicted that the network capacity was proportional to the geodesic distance between the imposed and the original distribution on the Wasserstein statistical manifold, \
            and further predicted optimal prior distributions for achieving the best generalization performance. Our theory and the accompanying algorithm provided a geometric approach to study learning under constraints. ",
    thumbnail:require("../editable-stuff/disco.png"), 
   },
   
   {
    category: "Machine Learning",
    title: "Generative modeling by disordered quantum systems",
    url:"https://arxiv.org/abs/2207.02346",
    present:require("../editable-stuff/MBL_Born_poster.png"),
    notes: "Can a quantum system be trained to perform generative modeling tasks? We proposed a class of quantum generative models that we have named “MBL hidden Born machines”. We proved that the trainability of basic Born machines could be tremendously improved by including hidden units, \
            and that the MBL Born machine possessed more expressive power than classical models. Our work revealed relationships between learning and physical dynamics that could serve as guiding principles for designing quantum generative models. ",
    thumbnail:require("../editable-stuff/MBL.png"), 
    // repo: "https://github.com/xunxdd/ILML---Google-Deep-Dream",
   },
   {
    category: "Machine Learning", 
    title: "Discriminative learning by out-of-equilibrium many-body systems",
    url:"https://arxiv.org/abs/2001.03623",
    notes: "We demonstrated that driven spin-glasses could perform a wide range of discriminative learning tasks that were usually only seen in digital systems, such as classification, memory, and novelty detection. \
            We further demonstrated that traditional thermodynamic variables were no longer effective in characterizing these novel many-body learning phenomena, \
            and that machine learning could make better predictions by using macroscopic variables constructed from nonlinear combination of traditional ones.",
    thumbnail:require("../editable-stuff/spin_glass.png"), 
    repo: "https://github.com/smarzen/Statistical-Physics", 
    // videoUrl:""
   }
  ]

};

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences, portfolio };
